<template>
    <transition name="modal">
        <div class="modal file-manager-modal modal-mask"
             @click="$emit('file-manager-modal-close')">
            <div :class="[size]"
                 class="modal-dialog"
                 @click.stop>
                <div class="modal-content">
                    <slot/>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {

        props: {
            'size': {
                default: "modal-lg",
                type: String
            }
        },

        mounted() {
            document.addEventListener('keydown', (e) => {
                if (this.show && e.keyCode === 27) {
                    this.close();
                }
            });
        }
    };
</script>
